import { render, staticRenderFns } from "./quick_task_table.vue?vue&type=template&id=ecfa1584&scoped=true"
import script from "./quick_task_table.vue?vue&type=script&lang=js"
export * from "./quick_task_table.vue?vue&type=script&lang=js"
import style0 from "./quick_task_table.vue?vue&type=style&index=0&id=ecfa1584&prod&lang=css"
import style1 from "./quick_task_table.vue?vue&type=style&index=1&id=ecfa1584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa1584",
  null
  
)

export default component.exports